import { AIChatMessage } from "@tellescope/ui";
import { AskAIVisualization } from "./AskAIVisualization";
import type { AIChatMessageWithVisualization } from "../types";

interface SenderInfo {
  name: string;
}

interface LocalMessageProps {
  message: AIChatMessageWithVisualization;
  senderInfo: SenderInfo;
}

export const LocalMessage = ({ message, senderInfo }: LocalMessageProps) => {
  return (
    <div className="max-w-3xl mx-auto space-y-2">
      {message.text && (
        <AIChatMessage
          role={message.role}
          content={message.text}
          timestamp={message.timestamp}
          sender={message.role === "user" ? senderInfo : undefined}
          onCopy={() => navigator.clipboard.writeText(message.text)}
        />
      )}
      {message.visualization && (
        <div className={message.text ? "ml-11 mt-4 mb-6" : "mb-6"}>
          <AskAIVisualization visualization={message.visualization} />
        </div>
      )}
    </div>
  );
};
